<template lang="pug">
  .hublespot.table
    .table-body
      hr
      .table-row.table-padding
        .table-col.table-col-collapsed
          img(src="/static/images/hubspot.svg")
        .table-col.title
          div {{ $t('integrations.title.hubspot') }}
          div.light-gray-text {{ $t('integrations.subtitle.hubspot') }}
        .table-col.table-col-collapsed.actions
          button.btn.btn-clean.btn-nylas(v-if='authorized && !show', @click='open') {{ $t('general.actions.configure') }}
          button.btn.btn-clean.btn-nylas(v-if='!authorized && !show', @click='connect') {{ $t('general.actions.connect') }}
    .form(v-show="show")
      button#close-form-button(type="button" class="close" aria-label="close" @click="close")
        span(aria-hidden="true") &times;
      div.hublespot__carousel
        span.indice 
          h4
            strong {{ $t('integrations.title.webhooksCapslock') }}
        .form-group.margin-top
          .form-group.margin-top(style="padding-bottom:20px;")
            input#hs_url.form-control(name="hs_url",type="text",:value="hs_url",:readonly='hs_carousel != null')
            button#btn-copy-hs-url.btn.btn-primary.btn-copy(@click='copyURLhs') {{ copied_hs ? $t('general.actions.copied') : $t('general.actions.copy') }}
          hr(style="padding-bottom:20px;").lines-div
          span.indice 
            h4  
              strong {{ $t('integrations.label.hubspot.receiveContactsTitle') }}
          span.ind 
            h6 {{ $t('integrations.label.hubspot.receiveContacts') }}:
          
          .checkbox-inline.margin-top(style="display: flex;")
            span(@click="setting.create_webhook = !setting.create_webhook")
              input(type='checkbox', :checked='setting.create_webhook')
              label.control-label(style="min-width: 465px; margin-right: 35px; margin-top: 5px; margin-bottom: 10px;") {{ $t('integrations.label.hubspot.addContacts') }}:
            stages-select(v-if='checkedCreateWebhook',
                      @click.stop='',
                      @item-selected-items='itemSelectedItems',
                      integration="hubspot_integration",
                      :filter_item_selected_ids='metadata_lifecycles')
          .info.info-rd(style="margin-top: 1em; ") {{ $t('integrations.label.hubspot.smartLeads') }}

          span.indice.indice-plus 
            h6 {{ $t('integrations.label.hubspot.contactsDistributionTitle') }}
          .flow-type-toggler-wrapper
            .toggler-inline.flow-type-toggle(@click='toggleUseCarousel()')
              input(type='checkbox' :checked='setting.use_carousel')
              label {{ use_carousel() }}
          .hublespot__info.info(v-if="setting.use_carousel == false") 
            p {{ $t('integrations.label.hubspot.eachUser') }}
            p {{ $t('integrations.label.hubspot.eachUserDescription') }}
        .form-group.margin-top(v-if="setting.use_carousel")
          .hublespot__info.info
            p {{ $t('integrations.label.hubspot.carousel') }}
            p {{ $t('integrations.label.hubspot.carouselDescription') }}
        .form-group.margin-top
          button.btn.btn-primary(v-if="setting.use_carousel", @click='loadHsCarouselData',data-toggle="modal", data-target="#hs-carousel-modal") {{ $t('integrations.label.setCarousel') }}

      carousel-modal(id="hs-carousel-modal", ref='hs_carousel_modal', :modal-title="modalTitle()", @savedCarousel='fillHsCarousel', kind='hs')
      hr.lines-div
      div.hublespot__funil
        .row.vertical-aligned(v-if='show_configuration_by_pipeline_name')
          .form-group.col-md-12
            .info.info-crm {{ $t('integrations.label.hubspot.configByPipeline') }}

        .row.vertical-aligned(v-if='show_configuration_by_pipeline_name')
          .form-group.col-md-6(:class="{'has-error': errors.has('pipeline')}")
            label(for='pipeline') {{ $t('integrations.attributes.funnelName') }}
            input.form-control.bcc-input(name="setting.pipeline",
                                        type="text",
                                        v-model='setting.pipeline',
                                        v-validate='',
                                        :placeholder="$t('integrations.placeholder.funnelName')")

          .form-group.col-md-6(:class="{'has-error': errors.has('stage')}")
            label(for='stage') {{ $t('integrations.attributes.funnelStage') }}
            input.form-control.bcc-input(name="setting.stage",
                                        type="text",
                                        v-model='setting.stage',
                                        v-validate='',
                                        :placeholder="$t('integrations.placeholder.funnelStage')")
        span.indice 
          h4  
            strong {{ $t('integrations.label.hubspot.sendContactsTitle') }}
        .row
          .col-md-7
            trigger-stages(
              @selected-stages='setStages'
              integration='hubspot'
              :settings='setting.triggers'
            )
          .col-md-5
            deal-lost(
              v-if='lost_checked || stage_lost'
              @selected='setMarkAs'
              :settings='setting.mark_as'
            )
        hr(style="padding-bottom:20px").lines-div
        span.indiceSyc.indice  
          h4 
            strong Hubspot Sync

        .hublespot__info.info {{ $t('integrations.label.hubspot.syncContacts') }}
        properties-matching(
          :properties_matching='properties_matching'
          integration_name='HubSpot'
          :api_fields='api_fields'
          @matching-updated='matchingUpdated'
        )

        stages-matching(
          :stages_matching='setting.stages_matching'
          integration_name='hubspot'
          :integration_stages='integration_stages'
          :pipelines='integration_pipelines'
          :pipeline_id='selected_pipeline'
          @matching-updated='matchingStagesUpdated'
          @users-update='updateUsers'
          @update-stages='changePipeline'
        )

        .row.vertical-aligned
          .col-md-12
            br
            button.pull-right.btn.btn-primary(@click="save") {{ $t('general.actions.save') }}
            button.pull-right.btn.btn-danger.btn-nylas(@click='disconnect') {{ $t('general.actions.disconnect') }}

</template>

<script>
const helpers = require("../../../helpers.coffee");
const users_resource = new UsersResource();

let view_model = {
  components: {
    carouselModal: require("../modal_carousel.vue"),
    triggerStages: require("./trigger_stages.vue"),
    dealLost: require("./deal_lost.vue"),
    propertiesMatching: require("./properties_matching.vue"),
    stagesMatching: require("./stages_matching.vue"),
    stagesSelect: require('../../shared/dropdown_multiple_kind/stage_filter.vue')
  },

  data() {
    return {
      current_user: Session.current_user,
      show: false,
      setting: new HubspotSetting(),
      hs_carousel: null,
      copied_hs: false,
      copied_hs_deal: false,
      stage_lost: false,
      properties_matching:
        Session.current_user.hubspot_setting.properties_matching,
      api_fields: [],
      matching: [],
      metadata_lifecycles: [],
      integration_stages: [],
      matching_stages: [],
      update_stages_all_users: false,
      integration_pipelines: [],
      selected_pipeline: { stage_query: null }
    };
  },

  computed: {
    authorized() {
      return this.setting.id;
    },

    hs_url() {
      if (this.has_configured_hs_carousel || !this.setting.use_carousel) {
        return (
          process.env.API_URL +
          "/webhooks/hubspot/import_contacts?token=" +
          this.current_user.authentication_token
        );
      } else {
        return (
          process.env.API_URL +
          "/webhooks/hubspot/import_contacts?token=" +
          this.current_user.authentication_token
        );
      }
    },

    has_configured_hs_carousel() {
      return (
        this.hs_carousel != null && this.hs_carousel.carousel_users.length > 0
      );
    },

    checkedCreateWebhook() {
      return this.setting.create_webhook;
    },

    show_configuration_by_pipeline_name() {
      if (!this.setting) return false;
      if (this.setting.pipeline) return true;
      return false;
    },

    lost_checked() {
      if (this.current_user.hubspot_setting.length == 0) return false;
      if (this.current_user.hubspot_setting.triggers.stages.filter ((item) => { return item == 'lost'}).length != 0) return true;
      return false;
    }
  },

  methods: {
    itemSelectedItems(stage) {
      this.metadata_lifecycles = stage
    },

    use_carousel() {
      if (this.setting.use_carousel)
        return this.$t('integrations.label.contactsViaCarousel');
      return this.$t('integrations.label.contactsViaResponsibleCRM');
    },

    toggleCreateWebhook() {
      if (this.has_configured_hs_carousel || !this.setting.use_carousel) {
        this.setting.create_webhook = !this.setting.create_webhook;
      }
    },

    checkLifecycle(stage) {
      if (!this.metadata_lifecycles) return false
      return this.metadata_lifecycles.indexOf(stage) > -1
    },

    open() {
      this.$router.push({ path: "/configuracoes/integracao?setting=hubspot" });
    },

    close() {
      this.$router.push({ path: "/configuracoes/integracoes" });
    },

    save() {
      this.$validator.validateAll().then(success => {
        if (success) {
          this.updateUser();
        }
      });
    },

    updateUser() {
      if(this.setting.create_webhook && this.metadata_lifecycles.length == 0 ){ 
        return alertify.error(this.$t('integrations.feedback.requiredLifeCicleStage'))
      }

      for(let stage of this.matching_stages) {
        if(!stage.reev || !stage.integration) return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'))
      }

      for(let property of this.matching) {
        property.type = this.api_fields.find((field) => { return field.key == property.integration }).type
      }

      this.setting.metadata.lifecycles = this.metadata_lifecycles
      Loader.on();
      let params = {
        id: Session.current_user.id,
        update_stages_all_users: this.update_stages_all_users,
        user_to_update_stages: this.user_to_update_stages,
        hubspot_setting_attributes: {
          id: this.setting.id,
          pipeline: this.setting.pipeline,
          metadata: this.setting.metadata,
          stage: this.setting.stage,
          create_webhook: this.setting.create_webhook,
          triggers: this.setting.triggers,
          use_carousel: this.setting.use_carousel,
          properties_matching: this.matching,
          stages_matching: this.matching_stages,
          mark_as: this.setting.mark_as
        }
      };
      new UsersResource().update(
        this.updateUserSuccess,
        this.handleApiErrors,
        params
      );
    },

    updateUserSuccess() {
      Loader.off();
      alertify.success(this.$t('general.feedback.settingUpdated'));
    },

    oauthUrl() {
      let params = jQuery.param({
        client_id: process.env.HUBSPOT_CLIENT_ID,
        response_type: "code",
        redirect_uri: `${window.location.protocol}//${window.location.host}/configuracoes/integracoes`,
        scope: "timeline oauth crm.objects.contacts.read crm.objects.contacts.write crm.objects.companies.write crm.schemas.contacts.read crm.objects.companies.read crm.objects.deals.read crm.objects.deals.write crm.schemas.companies.read crm.schemas.deals.read crm.objects.owners.read",
        state: "hubspot"
      });

      return `https://app.hubspot.com/oauth/authorize?${params}`;
    },

    matchingStagesUpdated(data) {
      this.matching_stages = data;
    },

    updateUsers(data) {
      this.update_stages_all_users = data.update_all_users;
      this.user_to_update_stages = data.user_id;
    },

    connect() {
      Loader.on();
      if (window.parent && Session.current_user.new_ui) return window.parent.postMessage({ type: "redirect-integration", route: this.oauthUrl() }, "*")
      window.location = this.oauthUrl();
    },

    disconnect() {
      Loader.on();
      let params = {
        id: Session.current_user.id,
        hubspot_setting_attributes: {
          id: this.setting.id,
          _destroy: 1,
          triggers: this.setting.triggers
        }
      };

      users_resource.update(
        this.disconnectSuccess,
        this.handleApiErrors,
        params
      );
    },

    disconnectSuccess() {
      Loader.off();
      this.close();
      this.setting = new HubspotSetting();
      alertify.success(this.$t('integrations.feedback.hubspotDisconnectSuccess'));
    },

    authorize() {
      Loader.on();
      let code = this.$route.query.code;
      this.$router.replace({ name: "integrations" });
      let params = { code: code }
      if (Session.current_user.new_ui) params.hubspot_redirect_uri = process.env.NEW_URL_REEV + this.$route.path
      IntegrationsResource.authorize_hubspot(this.authorizeSuccess, this.unknownError, params);
    },

    authorizeSuccess(response) {
      Session.updateCurrentUser(response.body.user);
      this.setting = Session.current_user.hubspot_setting;
      Loader.off();
      alertify.success(this.$t('integrations.feedback.hubspotConnectSuccess'));
    },

    copyURLhs() {
      jQuery("#hs_url").select();
      document.execCommand("copy");
      return (this.copied_hs = true);
    },

    loadHsCarouselData() {
      return this.$refs.hs_carousel_modal.loadData();
    },

    modalTitle() {
      if (this.current_user.isSeller()) {
        return this.$t('integrations.attributes.Carousel');
      } else {
        return this.$t('integrations.label.setCarousel');
      }
    },

    fillHsCarousel(carousel) {
      return (this.hs_carousel = carousel);
    },

    setStages(data) {
      this.setting.triggers = data;
      this.update_stage_lost(data.stages);
    },

    setMarkAs(data) {
      this.setting.mark_as = data;
    },

    toggleUseCarousel() {
      this.setting.use_carousel = !this.setting.use_carousel;
    },

    update_stage_lost(stages) {
      if (stages.filter ((item) => { return item == 'lost'}).length != 0) return this.stage_lost = true;
      return this.stage_lost = false;
    },

    matchingUpdated(data) {
      this.matching = data.filter(field => {
        return !(field.reev == undefined || field.reev == "");
      });
    },

    loadHubspotFields() {
      if (!this.setting.access_token) return;

      let opts = {
        params: { hapikey: this.setting.access_token },
        headers: {
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };

      Vue.http
        .get(`${process.env.API_URL}/hubspots/contact_properties`, opts)
        .then(response => {
          var regex = /^(?!hs_|hubspot|lifecyclestage|engagements|associated).*/;
          var body = response.body;
          body = body.map(field => {
            if (field.type == "string") {
              field.type = "text";
            }

            if (field.type == "datetime") {
              field.type = "date";
            }

            field.key = field.name;
            field.name = field.label;
            return field;
          });

          this.api_fields = body.filter(field => {
            return regex.test(field.name) && field.readOnlyValue != true && field.hidden != true && !field.referencedObjectType;
          });

          this.properties_matching =
            Session.current_user.hubspot_setting.properties_matching;
          if (
            !this.properties_matching ||
            this.properties_matching.length === 0
          ) {
            this.properties_matching = [
              {
                reev: "first_name",
                reev_name: this.$t('integrations.attributes.name'),
                integration: "firstname",
                integration_name: "firstname"
              },
              {
                reev: "last_name",
                reev_name: this.$t('integrations.attributes.lastname'),
                integration: "lastname",
                integration_name: "lastname"
              },
              {
                reev: "email",
                reev_name: this.$t('integrations.attributes.email'),
                integration: "email",
                integration_name: "email"
              },
              {
                reev: "telephone",
                reev_name: this.$t('integrations.attributes.telephone'),
                integration: "phone",
                integration_name: "Phone Number"
              },
              {
                reev: "cellphone",
                reev_name: this.$t('integrations.attributes.cellphone'),
                integration: "mobilephone",
                integration_name: "Mobile Phone Number"
              },
              {
                reev: "url",
                reev_name: this.$t('integrations.attributes.url'),
                integration: "website",
                integration_name: "website"
              }
            ];
          }
        });
    },

    loadHubspotStages() {
      if (!this.setting.access_token) return;

      let opts = {
        params: { hapikey: this.setting.access_token }
      };

      Vue.http
        .get(
          `${process.env.API_URL}/hubspots/pipeline_stages?pipeline_id=${this.selected_pipeline}`,
          opts
        )
        .then(response => {
          var body = response.body;
          this.integration_stages = body.map(stage => {
            return { name: stage.label, id: stage.stageId };
          });
        });
    },

    loadHubspotPipelines() {
      if (!this.setting.access_token) return;

      let opts = {
        params: { hapikey: this.setting.access_token }
      };

      Vue.http
        .get(`${process.env.API_URL}/hubspots/pipelines`, opts)
        .then(response => {
          var body = response.body;
          this.integration_pipelines = body.map(pipeline => {
            return {
              value: { stage_query: pipeline.pipeline_id },
              text: pipeline.label,
              stages: pipeline.stages.map(stage => {
                return { name: stage.label, id: stage.stageId };
              })
            };
          });
          this.integration_pipelines.unshift({
            value: { stage_query: null },
            text: this.$t('integrations.placeholder.funnel')
          });
          let pipeline = this.integration_pipelines[0].value.stage_query
          if(this.selected_pipeline) {
            if(this.selected_pipeline.stage_query) {
              pipeline = this.selected_pipeline.stage_query
            }
          }
          this.loadByNewPipeline({
            pipeline: {
              stage_query: pipeline
            }
          });
        });
    },

    loadByNewPipeline(data) {
      this.setting.metadata.pipeline_id = data.pipeline.stage_query
      this.selected_pipeline = data.pipeline
      if(this.setting.metadata) this.setting.metadata.pipeline_id = this.selected_pipeline.stage_query;
      let pipeline = this.integration_pipelines.find(pipe => {
        return pipe.value.stage_query == this.selected_pipeline.stage_query;
      });
      if(pipeline.stages){
        this.integration_stages = pipeline.stages;
      } else {
        this.loadHubspotStages()
      }
    },

    changePipeline(data) {
      this.setting.metadata.pipeline_id = data.pipeline.stage_query
      this.setting.stages_matching = []
      this.loadByNewPipeline(data)
    }
  },

  created() {
    if (this.$route.query.state == "hubspot" && this.$route.query.code) {
      setTimeout(this.authorize, 1000);
    }

    if (Session.current_user.hubspot_setting) {
      this.setting = Session.current_user.hubspot_setting
      if (this.setting.metadata !== undefined && this.setting.metadata.lifecycles) this.metadata_lifecycles = this.setting.metadata.lifecycles

      if (this.setting.metadata) {
        this.selected_pipeline = {
          stage_query: this.setting.metadata.pipeline_id
        };
      }
    }

    this.loadHubspotFields();
    this.loadHubspotPipelines();
    this.show = /integracao\?/.test(this.$router.currentRoute.fullPath);
  }
};

exports.default = helpers.vue_include(view_model, helpers.form);
</script>

<style lang="sass" scoped>

  @import '../../../assets/stylesheets/_variables.sass'

  .table
    margin: 0

  .title
    padding: 15px 0
    line-height: 20px

  .logo-box
    width: 50px
    height: 50px
    background: #f2f2f2
    padding: 3px
    margin-top: 10px

    img
      display: block
      width: 100%
      margin-top: 15px

  .form
    padding: 35px
    background: $lightest-gray
    text-align: center

    .form-group
      margin: 0
      display: inline-block
      text-align: left

    input.form-control
      width: 30em
      display: inline-block
      height: 38px
      margin-right: 15px

    .btn + .btn
      margin-left: 15px

    .btn
      vertical-align: top

    .btn-danger
      margin-right: 15px

  .actions
    text-align: center

  #close-form-button
    margin-top: -30px
    margin-right: -25px

  .table-padding
    padding-left: 20px
    padding-right: 20px

  .indice
    float: none
    color: $dark-slate-gray
    font-size: .9em
    text-align: left
    margin-bottom: 25px
    &.indice-plus
      margin-top: 15px
      padding-bottom: 10px

  .indiceSyc
    margin-top: 15px
    margin-bottom: 10px
    font-size: 18px
    float:left
  .ind
    float: none
    color: $dark-slate-gray
    font-size: .9em
    text-align: left
    margin-bottom: 25px
  
  .info
    float: none
    text-justify: inter-word
    color: $dark-slate-gray
    font-size: .9em
    text-align: left
    margin-bottom: 25px
    &.info-crm
      margin-top: 15px
      margin-bottom: 10px

  .vertical-aligned
    display: flex
    align-items: flex-start

  .bcc-input
    width: 100% !important

  .hublespot__carousel
    .form-group
      display: block

    .margin-top
      padding-top: 10px

  .flow-type-toggle input[type=checkbox]:checked + label:before
    background-color: rgb(0,170,234)
    border-color: rgb(0,170,234)

  .flow-type-toggle input[type=checkbox] + label:before
    background-color: #08d4a7
    border-color: #08d4a7
  .lines-div
    border-top: 1px solid $reev-base-green
</style>



// WEBPACK FOOTER //
// hubspot.vue?67dc9282